import { z } from "zod";

export const taskSchema = z.object({
  name: z
    .string()
    .min(1, "Internal name is required")
    .max(255, "Internal name must be less than 255 characters"),
  agendaTitle: z
    .string()
    .max(255, "External name must be less than 255 characters"),
  description: z
    .string()
    .max(5000, "Description must be less than 5000 characters")
    .optional()
    .or(z.literal("")),
  color: z.string().min(1, "Color is required"),
  taskStyle: z.string().min(1, "Task style is required"),
  statusId: z.number().optional().nullable(),
  categoryId: z.number().optional().nullable(),
  teamId: z.number().optional().nullable(),
  phaseId: z.number().optional().nullable(),
  tagsId: z.array(z.number()).optional().nullable(),
  clientId: z.number().optional().nullable(),
  budgetId: z.number().optional().nullable(),
});

export type TaskFormData = z.infer<typeof taskSchema>;